import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { isNullOrEmpty } from '../../../util/src/lib/is-null-or-empty';
import { AuthenticationService } from '../services/authentication.service';
import { StorageService } from '../services/storage.service';
import { Configuration } from './../../config/configuration';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private configuration: Configuration,
    private storageService: StorageService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const url = this.router.parseUrl(state.url);
    const systemGroup = url.queryParams.systemgroup;
    if(systemGroup !== undefined){
      this.storageService.session.setItem('systemGroup', systemGroup);
      // Todo: 測試完後下次更新移除
      console.log('Set session systemGroup:', systemGroup);
    }
    this.router.events.subscribe((event) => {
      
      if (event instanceof NavigationStart) {
        const eventObj = event as NavigationStart;
        const reloadUrl = this.storageService.session.getItem('reloadUrl');
        // 檢查是否為非內部 routing 方式
        if (
          eventObj.navigationTrigger !== 'imperative' &&
          eventObj.navigationTrigger !== 'popstate' &&
          ![reloadUrl, '/'].includes(eventObj.url)
        ) {
          this.router.navigate(['/']);
        }
      } else if (event instanceof NavigationEnd) {
        this.storageService.session.setItem('reloadUrl', event.url);
      }
      // if (
      //   event instanceof NavigationEnd &&
      //   event.id === 1 &&
      //   event.url === event.urlAfterRedirects
      // ) {
      //   this.storageService.local.setItem('reloadUrl', event.url);
      // }
    });
    const isAuthenticated = this.authenticationService.isAuthenticated;


    if (
      isAuthenticated &&
      this.authenticationService.checkIdTokenExpiration() === false
    ) {
      if (isNullOrEmpty(this.authenticationService.currentUserValue)) {
        const userNo = this.storageService.userProfile.getItem()?.userNo;
        if (userNo) {
          return this.authenticationService.initLoginUserData(userNo).pipe(
            tap((isSuccess) => {
              if (!isSuccess) {
                if (state.url === this.configuration.routePath.index) {
                  this.router.navigate([this.configuration.routePath.login]);
                } else {
                  this.router.navigate([this.configuration.routePath.login], {
                    queryParams: { redirectPath: state.url },
                  });
                }
              } else {
                if (!state.url.includes('/todo-item/')) {
                  this.checkRedirect(state.url);
                }
              }
            })
          );
        }
      }
    } else {
      if (state.url === this.configuration.routePath.index) {
        this.router.navigate([this.configuration.routePath.login]);
      } else {
        this.router.navigate([this.configuration.routePath.login], {
          queryParams: { redirectPath: state.url },
        });
      }
    }

    return isAuthenticated;
  }

  /**
   * 檢查是否有 lang 參數 (語系轉換導頁) 、 companyId 參數 (跨系統轉換導頁)
   *
   * @private
   * @param {string} url
   * @description
   *
   */
  private checkRedirect(url: string): void {
    const reloadUrl = this.storageService.session.getItem('reloadUrl');
    const isReloadPage = url === reloadUrl;
    const urlTree = this.router.parseUrl(url);

    // 因跨系統帶的paramter companyId,轉換為內部系統使用的路由結構
    if (
      urlTree.queryParams.companyId &&
      // 網址參數有 disableConvertUrl 時不進行轉換
      !urlTree.queryParams.disableConvertUrl
    ) {
      const companyId = urlTree.queryParams.companyId;
      delete urlTree.queryParams.companyId;
      const url = `/${companyId}${urlTree.toString()}`;

      this.router.navigateByUrl(url);
    } else {
      // 系統開啟新視窗時不導回首頁
      const isWindowOpen = url.includes('isWindowOpen=true');
      if (isReloadPage === false && !isWindowOpen) {
        this.router.navigate(['/']);
      }
    }

    // 因為在切換語系後重整，若 url 有帶 lang 參數，會造成重整後的語系與 lang 相同，
    // 所以此情況要移除 lang 參數。
    if (urlTree.queryParams.lang && isReloadPage) {
      delete urlTree.queryParams.lang;
      const url = urlTree.toString();
      this.router.navigateByUrl(url);
    }
  }
}
